<template>
  <div>
    <h2 class="text-h3 mb-24">{{ header }}</h2>
    <ul ref="listContainer">
      <li v-for="(item, index) in items" :key="rowKeys[index]" class="flex flex-row items-center mb-16">
        <TextField
          :id="`list-creator-${rowKeys[index]}`"
          v-model="items[index]"
          :type="type"
          :maxlength="`${maxCharacters}`"
          :labelName="labelName"
          class="w-full"
          :helperText="helperErrorMessages(item)"
          errorMessage
          :status="statusSetter(item)"
          aria-label="item"
        />
        <Button
          class="ml-10"
          :aria-label="`Remove ${item ? item : 'empty item'}`"
          variant="text"
          @click.prevent="removeItem(index)"
        >
          <ClearOutline color="#4b4c52" />
        </Button>
      </li>
    </ul>
    <Button
      v-if="items.length < maxItems"
      :value="buttonText"
      variant="outlined"
      class="w-full"
      size="small"
      @click.prevent="addNewItem"
    />
  </div>
</template>

<script lang="ts">
import ClearOutline from '../../graphics/icons/ClearOutlineIcon.vue';
import TextField from '../textfield/TextField.vue';
import Button from '../button/Button.vue';

export default {
  name: 'ListCreator',
  components: { ClearOutline, TextField, Button },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [''],
    },
    invalidItems: {
      type: Array,
      default: () => [''],
    },
    invalidItemsFormat: {
      type: Array,
      default: () => [''],
    },
    header: {
      default: '',
      type: String,
    },
    labelName: {
      default: 'Item',
      type: String,
    },
    maxCharacters: {
      type: Number,
    },
    minItems: {
      default: 0,
      type: Number,
    },
    maxItems: {
      default: 25,
      type: Number,
    },
    buttonText: {
      default: 'Add Item',
      type: String,
    },
    type: {
      default: 'text',
      type: String,
    },
    helperText: {
      default: '',
      type: String,
    },
    errorMessage: {
      default: '',
      type: String,
    },
    validationError: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      items: this.modelValue,
      rowKeys: Array.from({ length: this.modelValue.length }, (_, index) => index),
      nextRowKey: this.modelValue.length,
      status: 2,
    };
  },
  watch: {
    items(items) {
      this.$emit('update:modelValue', items);
    },
    modelValue(parentItems) {
      if (parentItems === this.items) return;

      this.items = parentItems;

      while (this.rowKeys.length < parentItems.length) {
        this.rowKeys.push(this.nextRowKey++);
      }

      if (this.rowKeys.length > parentItems.length) {
        this.rowKeys.splice(parentItems.length);
      }
    },
  },
  methods: {
    addNewItem(): void {
      this.$emit('add-item', this.items);
      this.items.push('');
      this.rowKeys.push(this.nextRowKey++);
      this.$nextTick(() => {
        const itemsList = (this.$refs.listContainer as any)?.children || [];
        itemsList[itemsList.length - 1]?.querySelector('input').focus();
      });
    },
    removeItem(index) {
      this.$emit('remove-item', index);
      if (this.items.length <= this.minItems) return;
      this.items.splice(index, 1);
      this.rowKeys.splice(index, 1);
    },
    statusSetter(item) {
      if ((this.invalidItems.includes(item) || this.invalidItemsFormat.includes(item)) && item.length > 0) {
        return 0;
      }
      return 2;
    },
    helperErrorMessages(item) {
      this.$emit('entered-email');

      if (this.type === 'email' && item) {
        return this.errorMessage;
      }

      if (this.invalidItems.includes(item)) {
        if (item === '') {
          return '';
        }
        return this.validationError;
      }

      if (this.invalidItemsFormat.includes(item)) {
        return this.errorMessage;
      }

      return this.helperText;
    },
  },
};
</script>
